import type { Filters } from '@/components/building-filters/BuildingFiltersProvider';
import { RESET_BUILDING_MORE_FILTERS_SEARCH_PARAMS } from '@/components/building-filters/search-params';
import { StatusQuoAnalysisTabEnum } from '@/routes/search_params/searchParamsEnums';

// Everything except portfolioIds/economicUnitIds/buildingIds, which are page-level scope, not per-tab.
export type MoreFilters = Pick<Filters, keyof typeof RESET_BUILDING_MORE_FILTERS_SEARCH_PARAMS>;

const MORE_FILTER_KEYS = Object.keys(RESET_BUILDING_MORE_FILTERS_SEARCH_PARAMS) as (keyof MoreFilters)[];

const TAB_FILTERS_STORAGE_PREFIX = 'tab-building-filters';

function getStorageKeyFor(storageKey: string, tab: StatusQuoAnalysisTabEnum) {
  return `${TAB_FILTERS_STORAGE_PREFIX}-${storageKey}-${tab}`;
}

function extractMoreFilters(filters: Filters): MoreFilters {
  return Object.fromEntries(MORE_FILTER_KEYS.map((key) => [key, filters[key]])) as MoreFilters;
}

export function stashTabFilters(storageKey: string, tab: StatusQuoAnalysisTabEnum, filters: Filters) {
  try {
    localStorage.setItem(getStorageKeyFor(storageKey, tab), JSON.stringify(extractMoreFilters(filters)));
  } catch {
    console.error('Error stashing tab filters', storageKey, tab, filters);
  }
}

export function restoreTabFilters(storageKey: string, tab: StatusQuoAnalysisTabEnum): MoreFilters {
  try {
    const stored = localStorage.getItem(getStorageKeyFor(storageKey, tab));
    return stored ? JSON.parse(stored) : RESET_BUILDING_MORE_FILTERS_SEARCH_PARAMS;
  } catch {
    return RESET_BUILDING_MORE_FILTERS_SEARCH_PARAMS;
  }
}
